import React from "react";
import Modal from "components/Modal";
import Button from "components/Button";
import styles from "../../features/main/HaulPay/Carrier/RequestPay/Documents/style.module.scss";
import ChunkUploadFile from "../ChunkUploadFile";
import { UploadedFile } from "models/Component";
import UploadItem from "../../features/main/Loads/modules/UploadItem";
import FRAttachmentItem from "../FRAttachmentItem";
import { IFRAttachment } from "../../models/HaulPay";

function UploadDocumentsModal({
  isOpen,
  closeModal,
  onCloseModal,
  title,
  urlCallback,
  dropzoneProps,
  isFundingRequest,
  fundingRequestId
}: {
  isOpen: boolean;
  closeModal: () => void;
  confirmButton?: () => void;
  onCloseModal?: () => void;
  title?: string;
  dropzoneProps?: { key: string };
  urlCallback: string;
  isFundingRequest?: false;
  fundingRequestId?: string;
}) {
  const [uploadedFiles, setUploadedFiles] = React.useState<UploadedFile[] | IFRAttachment[]>([]);
  return (
    <Modal
      isOpen={isOpen}
      closeModal={() => {
        onCloseModal && onCloseModal();
        closeModal();
      }}
      wrapperClass="!my-auto desktop:!min-h-fit text-sm"
      dialogClass="!bg-foreground !p-6 !border !border-card !overflow-y-auto gap-6 rounded-md shadow-lg w-12/12 max-w-4xl"
      closeClass="!hidden">
      <div className="flex flex-col">
        <p className="mt-2 text-xl font-semibold">{title}</p>
      </div>
      <div className={styles.uploadWrapper}>
        <ChunkUploadFile
          className="desktop:flex desktop:flex-col desktop:gap-4 desktop:text-lg "
          multiple
          maxSizeBytes={25 * 1024 * 1024}
          urlCallback={urlCallback}
          onUploadFinished={(files: any, fileId: string) => {
            const newFiles: any[] = files.map((file: any) => ({
              name: file.name,
              size: file.fileSize,
              type: file.fileType,
              fileType: file.categories.split(","),
              url: file.preview_url,
              fileId: fileId,
              id: fileId,
              filename: file.name,
              category: file.categories.split(","),
              downloadUrl: file.preview_url,
              visibleTo: file.visible_to
            }));
            setUploadedFiles([...uploadedFiles, ...newFiles]);
          }}
          {...dropzoneProps}
        />
        <p className="mt-2 text-xs text-label">Files must be under 25MB</p>
        <div className="my-3">
          {uploadedFiles.map((file) => (
            <div key={file?.fileId} className="-mx-2">
              {!isFundingRequest && !fundingRequestId ? (
                <UploadItem file={file as UploadedFile} />
              ) : (
                <FRAttachmentItem
                  key={file.fileId}
                  attachment={file as IFRAttachment}
                  showDelete
                  showPreview
                  showVisibleTo
                  fundingRequestId={fundingRequestId ?? ""}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end px-2 mt-6">
        <Button
          type="button"
          onClick={() => {
            onCloseModal && onCloseModal();
            closeModal();
          }}
          className="self-end text-white bg-orange-500 rounded-full w-30 h-9 hover:bg-orange-600">
          Finish
        </Button>
      </div>
    </Modal>
  );
}

export default UploadDocumentsModal;
